import type { AutoFitTextCreateConfig } from '../types';

/** Synthetic dispatch key for SETTINGS_BY_TYPE — AutoFitText presents as `type: 'textbox'`. */
export const AUTO_FIT_TEXT_SETTINGS_KEY = 'autoFitText';

export const AF_BOLD_WEIGHT = 700;
export const AF_REGULAR_WEIGHT = 400;

/** Defaults applied by createAutoFitText when the caller omits optional fields. */
export const AUTO_FIT_TEXT_FACTORY_DEFAULTS = {
  text: 'AutoFit text',
  width: 320,
  fill: '#000000',
  fontFamily: 'Arial',
  fontWeight: AF_REGULAR_WEIGHT as number | string,
  fontStyle: 'normal' as const,
  textAlign: 'center' as const,
  splitByGrapheme: false,
  autoFit: {
    minFontSize: 16,
    maxFontSize: 80,
    maxHeight: 120,
    snapTo: 2
  }
} as const;

/** Visual defaults for an AutoFitText inserted from the toolbar. Position is supplied by the caller. */
export const AUTO_FIT_TEXT_INSERT_DEFAULTS: Omit<AutoFitTextCreateConfig, 'left' | 'top'> = {
  text: 'AutoFit text',
  width: 320,
  fill: '#000000',
  fontFamily: 'Arial',
  fontWeight: AF_REGULAR_WEIGHT,
  textAlign: 'center',
  autoFit: {
    minFontSize: 16,
    maxFontSize: 80,
    maxHeight: 120,
    snapTo: 2
  }
};
